/*
  Patches Zipify One Click Upsell's Slide Cart Drawer to show the compare-at
  price and discount % for subscription (Recharge/Shopify selling plan) line
  items, which OCU's own "Compare at Price" / "Savings Label" settings do not
  cover — those only read the variant's static compare_at_price, not
  selling_plan_allocation.compare_at_price.

  OCU renders its own drawer independently of this theme, so this script
  reads the real cart data from /cart.js and injects the missing markup into
  OCU's rendered DOM after the fact, matched via each line item's data-key
  attribute (which mirrors Shopify's own line_item.key exactly).
*/
(function () {
  var OVERLAY_CLASS = 'ocu-discount-overlay';
  var WRAPPER_SELECTOR = '.ocu-cart-line-item-wrapper[data-key]';
  var PRICE_CONTAINER_SELECTOR = '.ocu-cart-line-price-container';

  var style = document.createElement('style');
  style.textContent =
    '.' + OVERLAY_CLASS + '--was {' +
      'margin: 5px 0 0px !important;' +
      'text-decoration: line-through;' +
      'color: var(--ocu-elements-color, #6b6b6b);' +
      'opacity: .65;' +
      'font-family: var(--ocu-main-font);' +
      'font-size: 12px;' +
    '}' +
    '.' + OVERLAY_CLASS + '--savings {' +
      'margin: 2px 0 0 !important;' +
      'color: var(--ocu-button-color, #CC5500);' +
      'font-family: var(--ocu-main-font);' +
      'font-size: 12px;' +
      'font-weight: 600;' +
    '}';
  document.head.appendChild(style);

  function formatMoney(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function' && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function applyOverlay(priceContainer, sellingPlanAllocation) {
    var compareAt = sellingPlanAllocation.compare_at_price;
    var price = sellingPlanAllocation.price;
    var existing = priceContainer.querySelector('.' + OVERLAY_CLASS + '--was');

    // Idempotent: skip work if this exact value is already shown
    if (existing && existing.getAttribute('data-value') === String(compareAt)) return;

    priceContainer.querySelectorAll('.' + OVERLAY_CLASS).forEach(function (el) { el.remove(); });

    var savedPercent = Math.round(((compareAt - price) / compareAt) * 100);

    var was = document.createElement('p');
    was.className = OVERLAY_CLASS + ' ' + OVERLAY_CLASS + '--was';
    was.setAttribute('data-value', String(compareAt));
    was.textContent = formatMoney(compareAt);

    var savings = document.createElement('p');
    savings.className = OVERLAY_CLASS + ' ' + OVERLAY_CLASS + '--savings';
    savings.textContent = '-' + savedPercent + '%';

    priceContainer.prepend(was);
    priceContainer.appendChild(savings);
  }

  function applyDiscounts(cart) {
    var wrappers = document.querySelectorAll(WRAPPER_SELECTOR);
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var key = wrapper.getAttribute('data-key');
      var item = cart.items.find(function (i) { return i.key === key; });
      if (!item || !item.selling_plan_allocation) return;

      var spa = item.selling_plan_allocation;
      if (!spa.compare_at_price || spa.compare_at_price <= spa.price) return;

      var priceContainer = wrapper.querySelector(PRICE_CONTAINER_SELECTOR);
      if (!priceContainer) return;

      applyOverlay(priceContainer, spa);
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(applyDiscounts)
      .catch(function (err) { console.warn('OCU discount overlay: cart fetch failed', err); });
  }

  var debounceTimer;
  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(refresh, 150);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.body, { childList: true, subtree: true });

    // Also catch the theme's own cart-update events as a faster, more direct trigger
    document.addEventListener('cart:build', scheduleRefresh);
    window.addEventListener('cart_changed', scheduleRefresh);
    document.addEventListener('ajaxProduct:added', scheduleRefresh);

    scheduleRefresh();
  });
})();
